import { Box, Modal, Stack, Step, StepConnector, StepLabel, Stepper, Typography, stepConnectorClasses, styled } from "@mui/material"
import { useEffect, useState } from "react";
import { TaskRecord, TaskStatus, TaskType } from "../types/Task";
import { LocationRecord } from "../types/Location";
import { Notification } from "./Notification";
import { RobotDetailData } from "../types/Robot";
import { NotificationYesNo } from "./NotificationYesNo";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { NotificationPinCode } from "./NotificationPinCode";

export const ProgressDeliveryTimeoutIndicationSimulation = (props: {
    taskRecord: TaskRecord | undefined,
    robot: RobotDetailData | undefined,
    handleCanceled: () => void,
    handleChangeState: (stateId: number) => void,
    intialLocalState: number,
}) => {
    const {taskRecord, robot, handleCanceled, handleChangeState, intialLocalState} = props;
    const [path, setPath] = useState<LocationRecord[]>(taskRecord ? taskRecord.path : [])
    const [currentProgress, setCurrentProgress] = useState<number>(0);

    const [failedDelivery, setFailedDelivery] = useState<boolean>(false);
    const [returnOpen, setReturnOpen] = useState<boolean>(false);
    const [localState, setLocalState] = useState<number>(intialLocalState)


    useEffect(() => {
        if (currentProgress < 5) {
            if (currentProgress !== 0) {
                const timer = setTimeout(() => {setCurrentProgress(currentProgress + 1)}, currentProgress === 3 && localState === 2 ? 7000 : 3000) 
                if (localState === 1 && currentProgress === 3) {
                    setFailedDelivery(true)
                    setReturnOpen(false)
                }
            }
        } else {
            if (localState === 0) {
                // show return notification
                handleChangeState(0) // 0 is back to original page
            } else if (localState === 1) {
                // wait indefinitely, so return to original page
                setFailedDelivery(false)
                setReturnOpen(true)
                // handleChangeState(0) // 0 is back to original page
            } else {
                // this screen shows delivery cancelled
            }
        }
    }, [currentProgress])

    const CustomConnector = styled(StepConnector)(({ theme }) => ({
        [`&.${stepConnectorClasses.active}`]: {
          [`& .${stepConnectorClasses.line}`]: {
            borderColor: "#1976d2",
          },
        },
        [`&.${stepConnectorClasses.completed}`]: {
          [`& .${stepConnectorClasses.line}`]: {
            borderColor: "#1976d2"
          },
        },
        [`& .${stepConnectorClasses.line}`]: {
            marginLeft: "4px",
            marginRight: "4px",
            marginTop:"9px",
            height: 3,
            width: "auto",
            borderRadius: 1,
            borderWidth: "5px"
        },
      }));


    const generateLabelSequence = (taskType: number) => {
        // const sequence = path.map(
        //     (location, i) => [{
        //         key: 2 * i, 
        //         title: (i===2 ? "Delivering to " : "Going to ") + location.location.displayName},
        //         {
        //          key: 1 + 2* i,
        //          title: "Arrived at " + location.location.displayName}
        //         ]).reduce((prev, pairs) => prev.concat(pairs), []);
        // console.log(sequence);
        const location = path.length > 0 ? path[0] : undefined; // hardcoded to only be one location, else is nothing
        console.log(location)
        const sequence =  [{
            key: 0,
            title: "Going to Pick Up at VES", //+ location?.location.displayName,
        },{
            key: 1,
            title: "Arrived at VES", //+ location?.location.displayName,
        }, {
            key: 2,
            title: "Delivering to Ward 14" //+ location?.location.displayName
        },{
            key: 3,
            title: "Arrived at Ward 14"
        }, {
            key: 4,
            title: currentProgress >= 3 && localState === 2 ? "Return to VES" : "Delivered" // + location?.location.displayName : "Delivered"
        }]
        return sequence
    }

    return <>
        <Box sx={{
            backgroundColor: "#eae6d0",
            height: "128px",
        }}>
        <Stack direction={"row"}>
            <Box sx={{
                width: "85%"
            }}>
                <Typography sx={{
                    fontSize: "28px",
                    fontWeight: "bold",
                    paddingLeft: "20px",
                    // paddingBottom: "6px",
                    paddingTop: "12px",
                }}>{
                taskRecord?.taskType === TaskType.SERVER_JOB ?
                "Pickup in progress" :
                "Delivery in progress"
            }</Typography>
            <Typography sx={{
                    fontSize: "22px",
                    paddingLeft: "20px",
                    paddingBottom: "24px",
                }}>{
                taskRecord?.taskType === TaskType.SERVER_JOB ?
                "Robot is serving your request" :
                "Robot is delivering your items"
            }</Typography>
            </Box>
        </Stack>
        </Box>
        <Stack direction="column" sx={{
            justifyContent: "center",
            alignContent: "center",
            paddingLeft: "48px",
            paddingRight: "48px",
            display: "flex",
        }}>
        <Box sx={{
            alignContent: "center",
            justifyContent: "center",
            width: "100%",
            display: "flex",
            paddingTop: "24px",
            paddingBottom: "24px"
        }}>
        <img src="./assets/navigating_logo.png" alt="Navigation in progress"/>
        </Box>
            <Stepper orientation="horizontal" activeStep={currentProgress} connector={<CustomConnector />} alternativeLabel>
                {generateLabelSequence(taskRecord ? taskRecord.taskType : 0)?.map(item => (
                <Step key={item.key} index={item.key}>
                    {/* <Stack direction="row"> */}
                        <StepLabel sx={{
                            ".MuiStepIcon-root": {
                                height: "48px !important",
                                width: "48px !important",
                                zIndex: 2,
                                },
                                "& .MuiStepConnector-line": {
                                    borderTopWidth: "12px",
                                  },
                        }}>
                            <Typography sx={{
                                fontSize: "20px",
                                // paddingLeft: "48px"
                            }}>{item.title}</Typography>
                        </StepLabel>
                        
                        {item.key === 3 
                        ? 
                            localState === 0 ? <Stack 
                                                justifyContent={"center"}  
                                                alignContent={"center"} 
                                                justifyItems={"center"} 
                                                direction={"row"} 
                                                sx={{
                                                    paddingTop: "12px"
                                                }}>
                                                    <AccessTimeIcon />
                                                    <Typography onClick={() => setLocalState(1)} sx={{color: "#FF0000"}} textAlign={"center"}> 10:00 </Typography> 
                                               </Stack>:
                            localState === 1 ? <Stack 
                                                justifyContent={"center"}  
                                                alignContent={"center"} 
                                                justifyItems={"center"} 
                                                direction={"row"} 
                                                sx={{
                                                    paddingTop: "6px"
                                                }}>
                                                    <Typography onClick={() => setLocalState(2)} sx={{color: "#FF0000"}} textAlign={"center"}> Waiting for receipient </Typography> 
                                                </Stack>:
                            localState === 2 ? <Stack 
                                                justifyContent={"center"}  
                                                alignContent={"center"} 
                                                justifyItems={"center"} 
                                                direction={"row"} 
                                                sx={{
                                                    paddingTop: "12px"
                                                }}><Typography onClick={() => setLocalState(0)} sx={{color: "#FF0000"}} textAlign={"center"}> Failed Delivery </Typography> 
                                                </Stack>
                                             : <></>
                        : <></>}
                    {/* </Stack> */}
                </Step>))}
            </Stepper> 
            <Modal disableEnforceFocus open={returnOpen}>
                <NotificationYesNo robot={robot} handleNo={() => {
                    handleChangeState(0);
                    setReturnOpen(false);
                } } handleYes={() => {
                    setCurrentProgress(0)
                    setReturnOpen(false);
                } } message={"The robot has returned "} displayImg={""} subtitle={"Do you want to resend the item?"} showYesNo={true}/>
            </Modal>
             <Modal disableEnforceFocus open={currentProgress === 0}>
                <NotificationPinCode robot={robot} handleLoadedItem={() => {setCurrentProgress(1)} } message={"Robot has arrived"} displayImg={""} subtitle={"Please attend to the robot"} completedText={"Dispatch Robot"}/>
            </Modal>
            <Modal disableEnforceFocus open={currentProgress === 4}>
                <Notification robot={robot} handleLoadedItem={ () => {setCurrentProgress(5)}} message={"Robot has completed delivery"} displayImg={""} subtitle={"Robot has completed delivery"} showDismiss={true}/>
            </Modal>
            <Modal disableEnforceFocus open={failedDelivery}>
                <Notification robot={robot} handleLoadedItem={() => {
                    setFailedDelivery(false);
                } } message={"Failed Delivery"} displayImg={""} subtitle={"Please wait for robot to return"} showDismiss={true}/>
            </Modal>
        </Stack>
    </>
}